import { Grid } from "@material-ui/core";
import SelectErp from "../../../../components/basics/SelectErp";
import { useState, useContext } from "react";

import Btn from "../../../../components/buttons/Btn";
import { formatDate } from "../../../../utils/formatDate";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import { getQyonOfx } from "../../../../repositories/qerpapi/erp/financeiro/ConciliacaoBancariaRepository";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import { notify } from "./../../../../utils/notify";
import { useEffect } from "react";

const ModalQyonBank = ({
  open = false,
  setModalOpen = () => {},
  setFile = () => {},
  setOpened = () => {},
  setLoading = () => {},
  handleUpload,
  agencies = [],
}) => {
  const { queryParams } = useContext(QueryParamsContext);

  const date = new Date();
  const [finalDate, setFinalDate] = useState(
    formatDate({ date: date, separator: "-", format: "yyyy-mm-dd" })
  );
  const [initialDate, setInitialDate] = useState(
    formatDate({
      date: new Date(date.setMonth(date.getMonth() - 1)),
      separator: "-",
      format: "yyyy-mm-dd",
    })
  );
  const [account, setAccount] = useState(null);
  const [accountQyonBank, setAccountQyonBank] = useState([]);

  useEffect(() => {
    if (!agencies) {
      return;
    }

    let agenciesFiltered = agencies.filter(
      (agency) => agency?.banco?.codigo === "000"
    );
    agenciesFiltered.map((agency) => {
      agency.nickName = `${agency.apelido} - (${agency.contacorrente}) `;
      return agency;
    });
    setAccountQyonBank(agenciesFiltered);
  }, [setAccountQyonBank, agencies]);

  const handleClose = () => {
    setFile([]);
    setModalOpen(false);
    setInitialDate(
      formatDate({ date: date, separator: "-", format: "yyyy-mm-dd" })
    );
    setFinalDate(
      formatDate({
        date: new Date(date.setMonth(date.getMonth() + 1)),
        separator: "-",
        format: "yyyy-mm-dd",
      })
    );
    setAccount(null);
  };

  // função que envia os dados digitados
  // pelo usuário para o back e retorna o arquivo.
  const confirmData = async () => {
    try {
      setLoading(true);

      const callback = await getQyonOfx({
        empresa_cnpj: queryParams.empresa_cnpj,
        agencia_id: account.id,
        empresa_id: queryParams.empresa_id,
        dataInicio: initialDate,
        dataFim: finalDate,
      });

      if (!callback.success)
        return notify(
          "Erro ao baixar arquivo OFX do Qyon Bank, verifique se sua conta está configurada corretamente."
        );

      await handleUpload({
        base64: callback.data,
        name: `Extrato-qyon-bank-${initialDate}-${finalDate}.ofx`,
      });

      // importante o arquivo ser colocado no índice
      // 0 do array.
      setFile([{}]);
      setOpened(true);
      handleClose();
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid
        container
        spacing={2}
        justifyContent="center"
        style={{ marginBottom: 20, marginTop: 40 }}
      >
        <Grid item sm={2} xs={4}>
          <SelectErp
            descriptionField="nickName"
            label="Conta"
            optionsList={accountQyonBank}
            value={account}
            setValue={setAccount}
          />
        </Grid>
        <Grid item sm={2} xs={4}>
          <TextFieldErp
            label="Início"
            type="date"
            value={initialDate}
            setValue={setInitialDate}
          />
        </Grid>
        <Grid item sm={2} xs={4}>
          <TextFieldErp
            label="Fim"
            type="date"
            value={finalDate}
            setValue={setFinalDate}
          />
        </Grid>
      </Grid>

      <Grid container justifyContent="flex-end" spacing={2}>
        <Grid item>
          <Btn
            autoFocus
            onClick={handleClose}
            bgcolor="tertiary"
            hovercolor="orange"
            label="Fechar"
          />
        </Grid>
        <Grid item>
          <Btn
            autoFocus
            onClick={confirmData}
            bgcolor="primary"
            hovercolor="orange"
            label="Confirmar"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default ModalQyonBank;
